/**
 * Runtime environment helper.
 *
 * In production, env vars are injected at container startup into window._env_.
 * In development, falls back to process.env (populated by react-scripts).
 */
export function getEnv(key) {
  return window._env_?.[key] || process.env[key];
}
